import { render, staticRenderFns } from "./M21.vue?vue&type=template&id=1bdf65f6&scoped=true"
import script from "./M21.vue?vue&type=script&lang=js"
export * from "./M21.vue?vue&type=script&lang=js"
import style0 from "./M21.vue?vue&type=style&index=0&id=1bdf65f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf65f6",
  null
  
)

export default component.exports